
import { Connection } from '@solana/web3.js';

export function createSolanaConnection(endpoint = "https://eu.shield.fogo.fluxrpc.com?key=Uv7jn3AtdJO9m6g0qKrqrg") {
  return new Connection(endpoint);
}
